import React, { Component } from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
// core components
import { Creatable } from "react-select";
import Card from "@material-ui/core/Card";
import ImageUpload from "../../../components/CustomUpload/ImageUpload.jsx";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import TextField from "@material-ui/core/TextField";
import Button from "components/CustomButtons/Button";
import GridContainer from "components/Grid/GridContainer.jsx";
import {
  // Switch,
  // FormControlLabel,
  // Select,
  // MenuItem,
  // InputLabel,
  FormControl,
  // Checkbox,
  // InputAdornment,
  // Input
} from "@material-ui/core";
import GridItem from "components/Grid/GridItem.jsx";
import SimpleReactValidator from "simple-react-validator";

import toastr from "toastr";
import { hist } from "../../..";

import axios from "../../../config/axios";
import { getAllCategories$ } from "../../../redux/actions/category.js";
import loaderIcon from "assets/img/loader.gif";

toastr.options = {
  closeButton: true
};

const validationStyle = {
  color: "red"
};

const addButtonProps = {
  color: "rose",
  round: true
};
const changeButtonProps = {
  color: "rose",
  round: true
};
const removeButtonProps = {
  color: "danger",
  round: true
};

// const ITEM_HEIGHT = 48
// const ITEM_PADDING_TOP = 8
// const MenuProps = {
//   PaperProps: {
//     style: {
//       maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//       width: 250
//     }
//   }
// }

class AddSpeaker extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.state = {
      action: "add",
      categoryList: [],
      category_id: "",
      name: "",
      speaker_image: "",
      category_name: "",
      speaker_images: [],
      speaker_bio: "",
      newCategory: "",
      speaker_id: "",
      disabled: false,
      loading: false
    };
  }

  componentDidMount() {
    this.props.handleGetCategoryList();
    if (this.props.location.state) {
      const { action, speaker } = this.props.location.state;
      if (action === "edit" || action === "view") {
        let { category } = speaker;
        this.setState({
          action,
          speaker_id: speaker.id,
          name: speaker.name,
          category_name: { label: category, value: category },
          speaker_bio: speaker.bio,
          speaker_image:
            speaker.speaker_images.length > 0
              ? speaker.speaker_images[0].path
              : ""
        });
        if (action === "view") {
          this.setState({ disabled: true });
        }
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.categoryListData !== prevProps.categoryListData) {
      let categoryList = [];
      this.props.categoryListData.data.map(category =>
        categoryList.push({ value: category.name, label: category.name })
      );
      this.setState({
        categoryList
      });
    }
  }

  inputHandler = event => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  submitForm = () => {
    // store().dispatch({ type: 'IS_LOADING', payload: true })
    this.setState({ loading: true });
    const {
      category_name,
      name,
      speaker_bio,
      speaker_images,
      action,
      speaker_id
    } = this.state;

    const requestBody = {
      name,
      category: category_name.value,
      bio: speaker_bio,
      speaker_images
    };

    if (this.validator.allValid()) {
      if (action === "add") {
        axios
          .post("speakers", requestBody)
          .then(res => {
            if (res.status === 200 || res.status === 201) {
              toastr.success("Speaker Created Successfully!");
              setTimeout(() => hist.goBack(), 1000);
            }
          })
          .catch(error => {
            // store().dispatch({ type: 'IS_LOADING', payload: false })
            this.setState({ loading: false });
            toastr.error(error.response.data.message);
          });
      } else {
        axios
          .put(`speakers/${speaker_id}`, requestBody)
          .then(res => {
            if (res.status === 200) {
              toastr.success("Speaker Updated Successfully!");
              setTimeout(() => hist.goBack(), 1000);
            }
          })
          .catch(error => {
            // store().dispatch({ type: 'IS_LOADING', payload: false })
            this.setState({ loading: false });
            toastr.error(error.response.data.message);
          });
      }
    } else {
      this.setState({ loading: false });
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  fileUploadHandler = file => {
    this.setState({
      speaker_image: file
    });
    let form = new FormData();
    form.append("image", file);
    axios
      .post("storage/speaker/upload-file", form)
      .then(res => {
        if (res.status === 200 || res.status === 201) {
          this.setState({ speaker_images: res.data.data });
        }
      })
      .catch(error => {
        toastr.error(error.response.data.message);
      });
  };

  createOption = label => ({
    label,
    value: label
  });

  handleCreate = inputValue => {
    const data = { name: inputValue };
    axios
      .post("categories", data)
      .then(res => {
        if (res.status === 200 || res.status === 201) {
          const newOption = this.createOption(inputValue);
          axios
            .get("categories")
            .then(res => {
              let categoryList = [];
              res.data.data.map(category =>
                categoryList.push({
                  value: category.name,
                  label: category.name
                })
              );
              this.setState({
                categoryList,
                category_name: newOption
              });
            })
            .catch(err => {
              toastr.error(err.response.data.message);
            });
        }
      })
      .catch(err => {
        toastr.error(err.response.data.message);
      });
  };

  render() {
    // const { classes } = this.props;

    const {
      // action,
      name,
      // speaker_images,
      // category_id,
      category_name,
      categoryList,
      speaker_image,
      speaker_bio,
      disabled,
      loading
      // roles
    } = this.state;
    return (
      <div className="add-category-form">
        <Card
          // className={classes.card}
          style={{ overflow: "-webkit-paged-x" }}
        >
          {loading ? (
            <div className="loader_icon">
              <img src={loaderIcon} alt="loader"/>
            </div>
          ) : (
            <React.Fragment>
              <CardContent>
                <form>
                  <GridContainer>
                    <GridItem md={12}>
                      <TextField
                        autoFocus
                        margin="dense"
                        id="speaker_name"
                        name="name"
                        label="Speaker Name*"
                        type="text"
                        fullWidth
                        value={name}
                        onChange={event => {
                          this.inputHandler(event);
                        }}
                        disabled={disabled}
                      />
                      {
                        <span style={validationStyle}>
                          {this.validator.message(
                            "Speaker Name",
                            name,
                            "required|min:3|max:35"
                          )}
                        </span>
                      }
                    </GridItem>
                    <GridItem md={12}>
                      <FormControl
                        // className={classes.formControl}
                        fullWidth
                        style={{ margin: "0.7rem 0" }}
                      >
                        <legend style={{ fontSize: "1rem" }}>Category</legend>
                        <Creatable
                          isClearable
                          options={categoryList}
                          value={category_name}
                          onChange={(inputValue, actionMeta) => {
                            if (inputValue && inputValue.value) {
                              this.setState({
                                category_name: inputValue
                              });
                            }
                          }}
                          onCreateOption={this.handleCreate}
                          isDisabled={disabled}
                        />
                      </FormControl>
                      {
                        <span style={validationStyle}>
                          {this.validator.message(
                            "category_name",
                            category_name,
                            "required"
                          )}
                        </span>
                      }
                      {/* {
                    <span style={validationStyle}>
                      {this.validator.message(
                        "category_name",
                        category_id,
                        "required"
                      )}
                    </span>
                  } */}
                    </GridItem>
                    <GridItem md={12}>
                      <TextField
                        autoFocus
                        margin="dense"
                        id="speaker_bio"
                        name="speaker_bio"
                        label="Speaker Bio*"
                        type="text"
                        multiline={true}
                        fullWidth
                        value={speaker_bio}
                        onChange={event => {
                          this.inputHandler(event);
                        }}
                        disabled={disabled}
                      />
                      {
                        <span style={validationStyle}>
                          {this.validator.message(
                            "speaker_bio",
                            speaker_bio,
                            "required"
                          )}
                        </span>
                      }
                    </GridItem>
                    <GridItem
                      md={12}
                      container
                      direction="column"
                      justify="center"
                      alignItems="center"
                      style={{ marginTop: "20px" }}
                    >
                      <legend>Speaker's Image</legend>
                      {disabled ? (
                        <img src={speaker_image} alt="speaker_img"></img>
                      ) : (
                        <ImageUpload
                          currentProduct={
                            speaker_image !== null && speaker_image.type
                              ? {
                                  image: URL.createObjectURL(speaker_image)
                                }
                              : speaker_image
                              ? { image: speaker_image }
                              : { image: "" }
                          }
                          uploadImage={this.fileUploadHandler}
                          addButtonProps={addButtonProps}
                          changeButtonProps={changeButtonProps}
                          removeButtonProps={removeButtonProps}
                        />
                      )}
                    </GridItem>
                  </GridContainer>
                </form>
              </CardContent>
              <CardActions style={{ float: "right" }}>
                <Button
                  variant="contained"
                  color="iseas"
                  onClick={this.submitForm}
                >
                  Submit
                </Button>
              </CardActions>
            </React.Fragment>
          )}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    categoryListData: state.category
  };
};

const mapDispatchToProps = dispatch => {
  return {
    handleGetCategoryList: () => dispatch(getAllCategories$.trigger())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(extendedFormsStyle)(AddSpeaker));



// WEBPACK FOOTER //
// ./src/views/ISEAS/SpeakerManagement/AddSpeaker.js